import { Component, Input } from '@angular/core';

@Component({
  selector: 'button[adfToolbarButton], a[adfToolbarButton]',
  imports: [],
  templateUrl: './toolbar-button.component.html',
  styleUrl: './toolbar-button.component.scss',
})
export class ToolbarButtonComponent {
  @Input({ required: true }) Icon!: string;
}
